import React, { Component, PropTypes } from 'react';

import {
  NitroHeading,
  NitroDivider,
  NitroButton,
  NitroDrawer,
  NitroButtonGroup,
  NitroNavBar,
  NitroParagraph,
  NitroPlaceholder
} from 'nitro-components';

import {
  ALLOCATION_DETAIL_HEADING,
  ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER,
  AALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NOTIFY_CONTENT,
  ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NOTIFY_CANCEL,
  ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NOTIFY_CONTINUE
} from '../content';

import styled from 'styled-components';
const NotifyContent = styled.section`
  padding: 20px;
  padding-top: 10px;
`
const ActionGroup = styled.section`
  padding: 20px 0px;
`

class AllocateDiffDriverNotify extends Component {
  onContinue = () => {
    this.props.allocateDiffDriverNotifyContinue();
  };

  render() {
    const {
      isOpen,
      close,
      back
    } = this.props;

    const allocateDiffDriverNotifyContent = (
      <section>
        <NitroNavBar
          label={ALLOCATION_DETAIL_HEADING}
          action={() => {
            back('differentDriverNotify');
          }}
          noPadding
        />
        <NitroPlaceholder size="30" />

        <NitroHeading size="1" label={ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER} align="center" />
        <NitroDivider sidePanel noTopPad />
        <NotifyContent>
          <NitroParagraph variant="base2" size="3" align="center">
            {AALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NOTIFY_CONTENT}
          </NitroParagraph>

        </NotifyContent>

        <ActionGroup>
          <NitroButtonGroup layout="horizontal" align="center">

            <NitroButton
              label={ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NOTIFY_CANCEL}
              action={() => {
                close('differentDriverNotify');
              }}
              size="small"
              block
            />

            <NitroButton
              label={ALLOCATED_INFO_ALLOCATE_DIFFERENT_DRIVER_NOTIFY_CONTINUE}
              variant="secondary"
              action={this.onContinue}
              size="small"
              block
            />
          </NitroButtonGroup>
        </ActionGroup>

      </section>
    );

    return (
      <NitroDrawer
        isOpen={isOpen}
        padding="32px"
        width={460}
        close={() => {
          close('differentDriverNotify');
        }}>
        {allocateDiffDriverNotifyContent}
      </NitroDrawer>
    );
  }
}

AllocateDiffDriverNotify.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
  allocateDiffDriverNotifyContinue: PropTypes.func,
  back: PropTypes.func
};

export default AllocateDiffDriverNotify;



// WEBPACK FOOTER //
// ./src/features/relocations/driver/components/AllocateDiffDriverNotify.js